module.exports = __webpack_public_path__ + "51cd42d945c2e0470b35ff6f21058422.jpg";